// src/components/Loader/Loader.jsx
import { Loader2 } from "lucide-react";

const Loader = ({ message = "Cargando..." }) => {
  return (
    <div className="flex flex-col items-center justify-center h-64 text-gray-700 dark:text-gray-200">
      <Loader2 className="animate-spin w-10 h-10 text-blue-600 mb-4" />
      <p className="text-sm font-medium">{message}</p>
    </div>
  );
};

export default Loader;